import RegisterPage from "../../../components/RegisterPage";
import './styles.scss'

const Register = () => {
    return <RegisterPage/>
}

export default Register